import { Request } from '~src/httpClient/serverApi/requests/Request';

import { ICancelBundleUploadParams } from '../types/IBundleUpload';
import { IExecution } from '../types/IExecution';

/**
 * The VizPortal `cancelUpload` Web Client method: cancels an upload by its bundle luid while the
 * execution is still created / uploading, before a background job is linked. Once the upload is
 * processing, cancel through {@link CancelExecutionRequest} on the background job id instead.
 */
export class CancelBundleUploadRequest extends Request<ICancelBundleUploadParams, IExecution> {
  constructor(params: ICancelBundleUploadParams) {
    super('cancelUpload', params);
  }
}
